import { render, staticRenderFns } from "./ReorderProject.vue?vue&type=template&id=3e853c61&scoped=true&"
import script from "./ReorderProject.vue?vue&type=script&lang=js&"
export * from "./ReorderProject.vue?vue&type=script&lang=js&"
import style0 from "./ReorderProject.vue?vue&type=style&index=0&id=3e853c61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e853c61",
  null
  
)

export default component.exports